import React from "react";
import { Body } from "@streeteasy/design-system/typography";
import { bool, func, number, shape, string } from "prop-types";

import * as S from "./styled";

const CalendarOption = ({
  createHref,
  handleAnalyticsEvent,
  icon,
  isSelfTarget,
  name,
  openHouseData,
  openHouseId
}) => {
  const href = createHref(openHouseData);

  return (
    <S.CalendarOptionContainer
      href={href}
      onClick={() => {
        handleAnalyticsEvent(openHouseId);
      }}
      rel="nofollow"
      target={isSelfTarget ? "_self" : "_blank"}
    >
      <S.Icon className={`fa ${icon}`} />
      <Body className="add-to-calendar">{name}</Body>
    </S.CalendarOptionContainer>
  );
};

CalendarOption.propTypes = {
  handleAnalyticsEvent: func,
  name: string.isRequired,
  icon: string.isRequired,
  createHref: func.isRequired,
  openHouseData: shape({
    listingAddress: string,
    listingLink: string,
    time: shape({
      startsAt: string,
      endsAt: string
    }),
    streamingUrl: string
  }).isRequired,
  openHouseId: number.isRequired,
  isSelfTarget: bool
};

CalendarOption.defaultProps = {
  handleAnalyticsEvent: () => {},
  isSelfTarget: false
};

export default CalendarOption;
